
import { defineComponent } from "vue";

export default defineComponent({
  name: "Spinner",
  props: {
    color: {
      type: String,
      default: "",
    },
  },
  computed: {
    Color(): string {
      return this.color || "var(--info)";
    },
  },
});
